
export default function Products() {
  const productCategories = [
    {
      id: 1,
      title: "スキンケア商品",
      description: "肌質に合わせた基礎化粧品シリーズ",
      image: "https://readdy.ai/api/search-image?query=Luxury%20skincare%20products%20collection%20with%20elegant%20glass%20bottles%2C%20cream%20jars%2C%20serums%20in%20minimalist%20packaging%2C%20soft%20natural%20lighting%2C%20clean%20white%20background%2C%20premium%20beauty%20cosmetics%20display%2C%20professional%20product%20photography&width=400&height=300&seq=skincare-products&orientation=landscape",
      items: ["クレンジング", "化粧水", "美容液", "クリーム"]
    },
    {
      id: 2,
      title: "メイクアップ商品",
      description: "プロ仕様の高品質メイクアップライン",
      image: "https://readdy.ai/api/search-image?query=Professional%20makeup%20products%20collection%20with%20colorful%20eyeshadow%20palettes%2C%20lipsticks%2C%20foundations%2C%20brushes%20arranged%20aesthetically%2C%20vibrant%20colors%2C%20beauty%20industry%20standard%2C%20high-end%20cosmetics%20display&width=400&height=300&seq=makeup-products&orientation=landscape",
      items: ["ファンデーション", "アイシャドウ", "リップスティック", "チーク"]
    },
    {
      id: 3,
      title: "ヘアケア商品",
      description: "髪質改善のための専門ヘアケアシリーズ",
      image: "https://readdy.ai/api/search-image?query=Premium%20hair%20care%20products%20with%20elegant%20bottles%20and%20tubes%2C%20shampoo%2C%20conditioner%2C%20hair%20treatment%20oils%2C%20salon-quality%20packaging%2C%20clean%20modern%20design%2C%20professional%20hair%20care%20collection&width=400&height=300&seq=haircare-products&orientation=landscape",
      items: ["シャンプー", "コンディショナー", "ヘアオイル", "スタイリング剤"]
    },
    {
      id: 4,
      title: "ネイル商品",
      description: "サロン品質のネイルケア・カラー商品",
      image: "https://readdy.ai/api/search-image?query=Professional%20nail%20care%20products%20with%20colorful%20nail%20polish%20bottles%2C%20nail%20tools%2C%20UV%20lamps%2C%20nail%20art%20supplies%2C%20salon%20equipment%2C%20vibrant%20nail%20colors%20display%2C%20manicure%20essentials&width=400&height=300&seq=nail-products&orientation=landscape",
      items: ["ネイルポリッシュ", "ベースコート", "トップコート", "ネイルケア用品"]
    },
    {
      id: 5,
      title: "美容機器",
      description: "最新技術を搭載した美容機器",
      image: "https://readdy.ai/api/search-image?query=Modern%20beauty%20devices%20and%20equipment%2C%20facial%20steamers%2C%20LED%20light%20therapy%20devices%2C%20ultrasonic%20cleaners%2C%20professional%20beauty%20technology%2C%20sleek%20white%20and%20silver%20design%2C%20spa%20equipment&width=400&height=300&seq=beauty-devices&orientation=landscape",
      items: ["フェイシャルスチーマー", "美顔器", "脱毛器", "マッサージ器"]
    },
    {
      id: 6,
      title: "業務用商材",
      description: "サロン・エステ向け業務用商材",
      image: "https://readdy.ai/api/search-image?query=Professional%20salon%20supplies%20and%20equipment%2C%20large%20containers%20of%20beauty%20products%2C%20professional-grade%20cosmetics%2C%20salon%20furniture%2C%20beauty%20industry%20wholesale%20products%2C%20commercial%20beauty%20supplies&width=400&height=300&seq=professional-supplies&orientation=landscape",
      items: ["業務用化粧品", "サロン用品", "施術用具", "消耗品"]
    }
  ];

  return (
    <section id="products" className="py-20 bg-yellow-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-green-800 mb-4">
            <strong>商品案内</strong>
          </h3>
          <div className="w-24 h-1 bg-yellow-500 mx-auto mb-6"></div>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            美容業界のプロフェッショナルから一般のお客様まで、幅広いニーズにお応えする高品質な美容商材をご提供いたします。
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
          {productCategories.map((category) => (
            <div key={category.id} className="bg-white rounded-lg shadow-lg border-2 border-yellow-400 overflow-hidden hover:shadow-xl transition-shadow">
              <img 
                src={category.image}
                alt={category.title}
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-6">
                <h4 className="text-xl font-bold text-green-800 mb-3">
                  <strong>{category.title}</strong>
                </h4>
                <p className="text-gray-600 mb-4">{category.description}</p>
                <ul className="space-y-2 mb-6">
                  {category.items.map((item, index) => (
                    <li key={index} className="flex items-center text-sm text-gray-700">
                      <i className="ri-check-line text-green-600 mr-2"></i>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <div className="bg-white p-8 rounded-lg shadow-lg border-2 border-green-800 max-w-4xl mx-auto">
            <h4 className="text-2xl font-bold text-green-800 mb-4">
              <strong>通信販売について</strong>
            </h4>
            <p className="text-gray-700 mb-6 leading-relaxed">
              全国のお客様に安心してご利用いただけるよう、迅速かつ安全な配送サービスを提供しております。
              ご注文から発送まで、丁寧に対応させていただきます。
            </p>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="w-16 h-16 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-shopping-cart-line text-green-800 text-2xl"></i>
                </div>
                <h5 className="font-bold text-green-800 mb-2">簡単注文</h5>
                <p className="text-sm text-gray-600">オンラインで24時間受付</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-truck-line text-green-800 text-2xl"></i>
                </div>
                <h5 className="font-bold text-green-800 mb-2">迅速配送</h5>
                <p className="text-sm text-gray-600">最短翌日お届け</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-shield-check-line text-green-800 text-2xl"></i>
                </div>
                <h5 className="font-bold text-green-800 mb-2">安心保証</h5>
                <p className="text-sm text-gray-600">品質保証・返品対応</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
